import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import ConfigObject from '../models/ConfigObject';

const initialState: ConfigObject = {
 siteUrl: '',
 siteUrlVostok: '',
 logoFileName: '',
 companyShortName: '',
 companyLongName: '',
 companyAddress: '',
 companyPhone: '',
 showChatWoot: '',
 chatWootUrl: '',
 chatWootSource: '',
 maxUrl: '',
 showVostokBanner: '',
 privacyPolicy: '',
 agreementWitPermissions: '',
 agreementWithoutPermissions: '',
 sliderPrefix: '',
 showPrivacyPolicy: '',
 showAgreement: '',
 signalRUrl: '',
 selectedLocation: '',
 logoMainHeight: '0',
 logoMenuHeight: '0',
 showMain: '0',
 showPayment: '0',
 showSupport: '0',
 showDevice: '0',
 showMap: '0',
 showSettings: '0',
 vkUrl: '',
 userManual: '',
 showDititalRubblePayment: '0',
};

export const configSlice = createSlice({
 name: 'config',
 initialState,
 reducers: {
  config: (state, action: PayloadAction<ConfigObject>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { config } = configSlice.actions;

export default configSlice.reducer;
